import { BOOKING_URL } from "../../services/common-urls";
import { HttpClient } from "../../services/http/http-client";

export const UserService = {
  findUnrelatedArtists: ({
    artistId
  }) => HttpClient.get(BOOKING_URL, {
    section: 'artist',
    action: 'unrelated_users',
    artist_id: artistId
  }),
  findUnrelatedArtistsByName: ({
    artistId,
    searchString
  }) => HttpClient.get(BOOKING_URL, {
    section: 'artist',
    action: 'search_unrelated_responsible_agents',
    artist_id: artistId,
    search: searchString,
    tableID: 'unrelated_agents'
  }),
  addUserToArtist: ({
    artistId,
    userIds
  }) => HttpClient.get(BOOKING_URL, {
    section: 'artist',
    action: 'add_user_of_artist',
    artist_id: artistId,
    user_ids: userIds,
    // checked_user_ids: 1,1,1,1,1,1,1,1
  }),
}